import React from "react";
import { Menu, MenuItem, IconButton } from "@mui/material";
import { ReactComponent as FilterStack } from "../components/icon/filterstack.svg";
import CloseIcon from "@mui/icons-material/Close";

interface FilterMenuProps {
  filters: Record<string, string>;
  selectedFilters: string[];
  onToggleFilter: (filter: string) => void;
  onRemoveFilter: (filterKey: string) => void;
  anchorEl: null | HTMLElement;
  open: boolean;
  onClose: () => void;
  onOpen: any;
}

const FilterMenu: React.FC<FilterMenuProps> = ({
  filters,
  selectedFilters,
  onToggleFilter,
  onRemoveFilter,
  anchorEl,
  open,
  onClose,
  onOpen,
}) => {
  return (
    <>
      <IconButton
        onClick={onOpen}
        style={{ height: 37, padding: 0, marginTop: "1%" }}
      >
        <FilterStack height={39} width={90} />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={onClose}
        MenuListProps={{
          disablePadding: true,
          variant: "selectedMenu",
        }}
        style={{
          padding: "5px 0px",
        }}
      >
        <ul
          style={{
            backgroundColor: "#F3F2FF",
            padding: 0,
            margin: 0,
            listStyleType: "none",
          }}
        >
          {Object.keys(filters).map((filter) => (
            <MenuItem
              key={filter}
              onClick={() => onToggleFilter(filters[filter])}
              style={{
                backgroundColor: selectedFilters.includes(filters[filter])
                  ? "#E0E0E0"
                  : "#F3F2FF",
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "8px 16px",
                marginBottom: "2px",
              }}
            >
              <span>{filter}</span>
              {selectedFilters.includes(filters[filter]) && (
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    onRemoveFilter(filters[filter]);
                  }}
                  style={{
                    marginLeft: "10px",
                    color: "#555",
                  }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              )}
            </MenuItem>
          ))}
        </ul>
      </Menu>
    </>
  );
};

export default FilterMenu;
